import { render, staticRenderFns } from "./SaveDraftConfirm.vue?vue&type=template&id=72443ea9&"
import script from "./SaveDraftConfirm.vue?vue&type=script&lang=ts&"
export * from "./SaveDraftConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports